import { ICartAddressDetails, ICartDetailsPetCartItemData, ICartHdCartItem } from "@/api_framework/api_modals/Cart";
import React from "react";
import { BiError } from "react-icons/bi";
import { ICartOutOfStockListing } from "../CartCreationComponent";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICartState } from "@/app_redux/reducers/slices/auth/cart_slice";

const CartStockIncompleteComponent: React.FC<{
  stockOutItems: ICartOutOfStockListing[];
  selectedAddress?: ICartAddressDetails | null;
}> = ({ stockOutItems }) => {
  const { getRouteKey } = useRouter();
  const { activeCartDetails } = useRouteInfo(getRouteKey("CART_MANAGEMENT", "id"))?.routeState?.state as ICartState;

  const hdCartOutOfStockItems =
    activeCartDetails?.hd_cart?.out_of_stock_items?.map((item) => ({
      petId: null,
      outOfStockItems: [item],
    })) ?? [];

  const combinedStockOutItems = [...(stockOutItems ?? []), ...hdCartOutOfStockItems];
  const allOutOfStockItems = combinedStockOutItems
    .flatMap((i) => (i?.outOfStockItems || []) as (ICartHdCartItem | ICartDetailsPetCartItemData)[])
    .filter((item) => item && Object.keys(item).length > 0);
  const totalOutOfStockItems = allOutOfStockItems.length;
  if (totalOutOfStockItems === 0) return null;

  return (
    <div className="bg-white shadow-md p-4 mt-2 rounded-xl">
      <div className="flex items-center gap-2">
        <BiError color="#f72e03" size="18" />
        <h1 className="font-medium text-[#F72F03] text-base">Out of Stock Items</h1>
      </div>

      <div className="p-4">
        <ul className="space-y-2 mt-0 pl-3 list-none">
          {combinedStockOutItems?.map((ot, idx) =>
            ot.outOfStockItems?.length > 0 ? (
              <li key={idx} className="relative text-xs">
                <ul>
                  {ot.outOfStockItems?.map((ots) => {
                    const isFromHdCart = "vetic_variant_id" in ots && !!ots.vetic_variant_id;
                    const itemIdToSend = isFromHdCart ? ots.vetic_variant_id : ots.id;
                    return (
                      <li key={itemIdToSend} className="flex justify-between items-center gap-x-2 py-0.5">
                        <span className="before:left-[-15px] before:absolute before:content-['•'] before:text-[#000000] text-[#000000] font-medium text-xs">
                          {ots.name}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </li>
            ) : null,
          )}
        </ul>
      </div>
    </div>
  );
};

export default CartStockIncompleteComponent;
